import styled from 'styled-components';

export const ViewDetailsDiv = styled.div`
  position: absolute;
  right: 50px; /* Adjust the right position as needed */
  display: flex;
  align-items: center;
  z-index: 1; /* Increase the z-index value as needed */
`;
